import { PartnerGroupRules } from 'src/graphql/entities/group-rules/group-rules.types';
import { SITE_CARD_PROPERTY_KEYS } from 'src/graphql/entities/side-panel-personalization/model/card-keys';
import type { SidePanelPropertyDescriptor } from 'src/graphql/entities/side-panel-personalization/model/descriptors';

// visibility catalog for the associated-site fields (rendered on the site cards
// via the associated-site form). Shared by the conversation surface and the
// client surface. No Row components — card-rendered.
export const SITE_SECTION_PROPERTIES: SidePanelPropertyDescriptor[] = [
  {
    key: SITE_CARD_PROPERTY_KEYS.serviceLevel,
    label: 'Service Level',
    defaultVisible: true,
    icon: 'circle-check',
    iconLibrary: 'lucide',
    // only renders when the partner has SLA access; the engine drops the toggle otherwise
    allowedRules: [PartnerGroupRules.AccessToPlatformSLAs],
  },
  {
    key: SITE_CARD_PROPERTY_KEYS.accountManager,
    label: 'Account Manager',
    defaultVisible: true,
    icon: 'user',
    iconLibrary: 'lucide',
  },
  {
    key: SITE_CARD_PROPERTY_KEYS.labels,
    label: 'Labels',
    defaultVisible: true,
    icon: 'tags',
    iconLibrary: 'lucide',
  },
];
